import React from 'react';

import { ISO_DATE_FORMAT } from '@gasbi/shared';
import dayjs from 'dayjs';
import { Navigate } from 'react-router-dom';

import { Pages } from '@/pages';

const AllocationPreliminaryLayout = React.lazy(() => import('./index'));
const Import = React.lazy(() => import('./views/import/Import'));
const ImportDetail = React.lazy(
  () => import('./views/ImportDetail/ImportDetail'),
);
const Result = React.lazy(() => import('./views/Result/Result'));
const OperatorDetail = React.lazy(() => import('./views/OperatorDetail'));

const allocationPreliminaryRoute = [
  {
    element: <AllocationPreliminaryLayout />,
    children: [
      {
        path: Pages.ALLOCATION_PRELIMINARY,
        element: (
          <Navigate
            to={`./${dayjs().format(ISO_DATE_FORMAT)}`}
            relative='path'
          />
        ),
      },
      {
        path: `${Pages.ALLOCATION_PRELIMINARY}/:date`,
        element: <Import />,
      },
      {
        path: `${Pages.ALLOCATION_PRELIMINARY}/:date/${Pages.ALLOCATION_PRELIMINARY_RESULT}`,
        element: <Result />,
      },
    ],
  },
  {
    path: `${Pages.ALLOCATION_PRELIMINARY}/:date/${Pages.ALLOCATION_PRELIMINARY_IMPORT_DETAIL}`,
    element: <ImportDetail />,
  },
  {
    path: `${Pages.ALLOCATION_PRELIMINARY}/:date/${Pages.ALLOCATION_PRELIMINARY_RESULT}/${Pages.ALLOCATION_PRELIMINARY_OPERATOR_DETAIL}`,
    element: <OperatorDetail />,
  },
];

export default allocationPreliminaryRoute;
